import angular from "angular";

angular
    .module('app')
    .component('employeeForm', {
        template: require('./employee-form.html'),
        controller: ['$http', 'notifier', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, notifier, moment) {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.mode = $ctrl.resolve.mode;
        $ctrl.organization = $ctrl.resolve.organization;
        $ctrl.client = $ctrl.resolve.client;
        $ctrl.fields = $ctrl.resolve.fields;
        $ctrl.employee = $ctrl.resolve.employee;

        $ctrl.getCitizenshipList();

        $ctrl.lastName = $ctrl.employee ? $ctrl.employee.last_name : null;
        $ctrl.firstName = $ctrl.employee ? $ctrl.employee.first_name : null;
        $ctrl.patronymic = $ctrl.employee ? $ctrl.employee.patronymic : null;
        $ctrl.gender = $ctrl.employee ? $ctrl.employee.gender : null;
        $ctrl.birthDate = $ctrl.employee ? moment($ctrl.employee.birth_date).toDate() : null;
        $ctrl.citizenshipCode = $ctrl.employee ? $ctrl.employee.citizenship_code : null;
        $ctrl.iin = $ctrl.employee ? $ctrl.employee.iin : null;
        $ctrl.firstNameEn = $ctrl.employee ? $ctrl.employee.first_name_en : null;
        $ctrl.lastNameEn = $ctrl.employee ? $ctrl.employee.last_name_en : null;
        $ctrl.phoneNumber = $ctrl.employee && $ctrl.employee.phone_number ? $ctrl.employee.phone_number.substr(1) : null;
        $ctrl.email = $ctrl.employee ? $ctrl.employee.email : null;

        $ctrl.fieldValues = {};

        $ctrl.fields.forEach(field => {
            if (field.pivot.default_value) {
                $ctrl.fieldValues[field.id] = field.type === 'numeric'
                    ? (!isNaN(field.pivot.default_value) ? +field.pivot.default_value : null)
                    : null;
            }
        });

        $ctrl.documents = [{
            type: null,
            number: null,
            issueDate: null,
            expireDate: null,
        }];

        if ($ctrl.employee) {
            $ctrl.documents = $ctrl.employee.docs.map(v => {
                return {
                    type: v.type,
                    number: v.number,
                    issueDate: v.issue_date ? moment(v.issue_date).toDate() : null,
                    expireDate: v.expire_date ? moment(v.expire_date).toDate() : null,
                }
            })

            $ctrl.fields.forEach(field => {
                const fieldValue = $ctrl.employee.field_values.find(v => v.field_id === field.id);

                if (fieldValue) {
                    $ctrl.fieldValues[field.id] = field.type === 'numeric'
                        ? (!isNaN(fieldValue.value) ? +fieldValue.value : null)
                        : fieldValue.value;
                }

                if (!$ctrl.fieldValues[field.id] && field.pivot.default_value) {
                    $ctrl.fieldValues[field.id] = field.type === 'numeric'
                        ? (!isNaN(field.pivot.default_value) ? +field.pivot.default_value : null)
                        : null;
                }
            });
        }
    };

    $ctrl.getCitizenshipList = () => {
        $http.get('/data/get-citizenship-list').then(res => {
            $ctrl.citizenshipList = res.data;
        });
    };

    $ctrl.submit = () => {

        $ctrl.loading = false;

        const params = {
            first_name: $ctrl.firstName,
            last_name: $ctrl.lastName,
            patronymic: $ctrl.patronymic,
            gender: $ctrl.gender,
            birth_date: moment($ctrl.birthDate).format('YYYY-MM-DD'),
            citizenship_code: $ctrl.citizenshipCode,
            iin: $ctrl.iin,
            first_name_en: $ctrl.firstNameEn,
            last_name_en: $ctrl.lastNameEn,
            phone_number: $ctrl.phoneNumber ? '7' + $ctrl.phoneNumber : null,
            email: $ctrl.email,
            documents: $ctrl.documents.map((v, ind) => {
                return {
                    type: v.type,
                    number: v.number,
                    issue_date: v.issueDate ? moment(v.issueDate).format('YYYY-MM-DD') : null,
                    expire_date: v.expireDate ? moment(v.expireDate).format('YYYY-MM-DD') : null,
                }
            }),
            field_values: $ctrl.fields.map(v => {
                return {
                    field_id: v.id,
                    value: $ctrl.fieldValues[v.id],
                }
            })
        };

        let url = '';

        if ($ctrl.mode === 'from-clients') {
            url = $ctrl.employee
                ? `/clients/${$ctrl.client.id}/employees/${$ctrl.employee.id}`
                : `/clients/${$ctrl.client.id}/employees`;
        } else {
            url = $ctrl.employee
                ? `/control-panel/organizations/${$ctrl.organization.id}/clients/${$ctrl.client.id}/employees/${$ctrl.employee.id}`
                : `/control-panel/organizations/${$ctrl.organization.id}/clients/${$ctrl.client.id}/employees`;
        }

        $http
            .post(url, params)
            .then(() => {
                notifier.successNotify(
                    $ctrl.employee ? 'Данные успешно обновлены' : 'Сотрудник успешно добавлен', 2000
                );

                $ctrl.close();
            })
            .catch(err => {
                notifier.errorResponseNotify(err);
            })
            .finally(() => {
                $ctrl.loading = false;
            });
    };

    $ctrl.addDoc = () => {
        $ctrl.documents.push({
            type: null,
            number: null,
            issueDate: null,
            expireDate: null,
        });
    };

    $ctrl.delDoc = (ind) => {
        $ctrl.documents.splice(ind, 1);
    };

}



// WEBPACK FOOTER //
// ./resources/assets/modules/components/employee-form/employee-form.js